import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'

import { Link, useHistory } from 'react-router-dom'
import {BiDiamond} from 'react-icons/bi'
import {RiVipDiamondLine} from 'react-icons/ri'
import { isDarkMode } from '../../utils/util'


import wingoPic from './img/wingo.webp'
import k3Pic from './img/k3.webp'
import _5dPic from './img/5d.webp'
import trxwingoPic from './img/trxwingo.webp'
import logo from './img/logo.svg'
import { TabProps } from '../LotteryTab'
import { useCurrentGame } from '../../hooks/useDraw'
import { useTranslation } from 'react-i18next'
import { Button, Modal, Space, theme } from 'antd'
import hacker from './img/hacker.png'
import telegram from './img/telegram.png'
import whatsapp from './img/whatsapp.png'
import Parse from 'parse'
import bannerBg from './img/banner_bg.png'
import { useDomainConfig } from '../../hooks/useDomainConfig'
import Spacer from '../Spacer'
import {Helmet} from "react-helmet";
import { IoIosArrowDown } from "react-icons/io";
// import { useDomainConfig } from '../../hooks/useConfig'
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from "react-icons/md";

import lang_en from './img/lang_en.svg'
import lang_hi from './img/lang_hi.svg'
import lang_id from './img/lang_id.svg'
import lang_ur from './img/lang_ur.svg'
import app from './img/app.svg'

import DocumentTitle from 'react-document-title'
import { blue } from '../../theme/colors'
import stores from '../../state'
import { useSetLanguage } from '../../views/LanguageSet/LanguageSet'
interface ButtonProps {
  children?: React.ReactNode, 
  disabled?: boolean,
  href?: string,
  onClick?: () => void,
  size?: 'sm' | 'md' | 'lg',
  text?: string,
  to?: string,
  variant?: 'default' | 'secondary' | 'tertiary'
}


const StyledWrapper = styled.div`
  width: 100%;
  // background: linear-gradient(90deg,${props=>props.theme.color.primary.main} 0%,${props=>props.theme.color.primary.light} 100%); 
  padding: 10px; 
  padding-top: 30px;
  position: relative;
`

const StyledCardWrapper = styled.div`
  // background: linear-gradient(157deg,#FA5F5F 0%,#FF8C82 100%);
  filter: drop-shadow(0 .10667rem .21333rem rgba(208,208,237,.36));
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  text-shadow: 0 .09667rem .05333rem #F74747;
`


  
export const useLanguages = ()=>{
  return useMemo(()=>{
    return [{
      title:'English',
      langCode:'en',
      logo: lang_en },
      {
      title:'हिन्दी',
      langCode:'hd',
      logo: lang_hi },
      // {
      // title:'پاکستانی',
      // logo: lang_ur },
      // {
      // title:'Indonesia',
      // logo: lang_id }
    ]
  },[])
}
const LotterySegmentTab: React.FC= () => {
  const  lotteries = useMemo(()=>{
    return [
      {name:'WinGo',img:wingoPic},
      {name:'K3',img:k3Pic},
      {name:'5D',img:_5dPic},
      {name:'TrxWinGo',img:trxwingoPic},
    ]
  },[])
  const [selectedTab,setSelectedTab] = useState(0)
  const game = useCurrentGame()
  useEffect(()=>{
    lotteries.forEach((item,i)=>{
        if(item.name.toLowerCase() === game){
          setSelectedTab(i)
        }
      })
  },[game])
  // useEffect(() => {
  //   const handleHashChange = () => {
  //     const _game = new URL(window.location.href).hash.replace('#/','')
  //     lotteries.forEach((item,i)=>{
  //       if(item.name.toLowerCase() === _game){
  //         setSelectedTab(i)
  //       }
  //     })
  //     // setSelectedTab(__game)
  //     // console.log('game',_game)
  //     // Perform actions based on the changed hash
  //   };
  //   handleHashChange()
  //   window.addEventListener('hashchange', handleHashChange);
  //   return () => {
  //     window.removeEventListener('hashchange', handleHashChange);
  //   };
  // }, []);
  const history = useHistory()
  const {i18n,t} = useTranslation()
  const domainConfig = useDomainConfig()
  const [showLanModal,setShowLanModal] = useState(false)
  const langRef = useRef<HTMLDivElement>()
  const [modalPosition,setModalPosition] = useState()
  const [langIndex,setLangIndex] = useState(undefined)
  const {setLanguage} = useSetLanguage()
  const languages = useLanguages()
  useEffect(()=>{
      setLangIndex(stores.TodoList.langIndex)
  },[])
 useEffect(()=>{
    if(langIndex===undefined){
      return
    }
    setLanguage(languages[langIndex].langCode)
 },[langIndex])

  if(!domainConfig){
    return <></>
  }
  return <StyledWrapper>
      {domainConfig?.get('description') &&<Helmet>
        {/* <title>My Title</title> */}
        <meta name="description" content={domainConfig.get('description')} />
    </Helmet> }
    {domainConfig?.get('keywords') &&<Helmet>
        {/* <title>My Title</title> */}
        <meta name="keywords" content={domainConfig.get('keywords')} />
    </Helmet> }
    {domainConfig?.get('title') &&<Helmet>
        {/* <title>My Title</title> */}
        <title>{domainConfig?.get('title')}</title>
    </Helmet> }
    {/* <DocumentTitle title={domainConfig?.get('title')} /> */}
        <span style={{position:'absolute',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between',padding:10,left:0,top:0,right:0,color:'white',zIndex:10}} >
          <img src={logo} style={{height:20}}/>
          <div style={{display:'flex',flexDirection:'row'}}>
            <span style={{marginRight:10}} onClick={()=>window.open(domainConfig.get('loginURL'),'_blank')}>{t('Login')}</span>
            <div style={{background:'#E8F0FF',borderRadius:100,width:30,height:30,marginRight:10, display:'flex',justifyContent:'center', flexDirection:'row',alignItems:'center',}}>
              <img src={app} style={{width:20,height:20}} />
            </div>
            <div ref={langRef} style={{height:30,background:'#E8F0FF',display:'flex',flexDirection:'row',alignItems:'center',color:'black',borderRadius:100,paddingLeft:7,paddingRight:7}}  onClick={()=>{
              // history.push('language')
              const pos = langRef.current.getClientRects()[0]
              console.log('langRef',pos)
              
              setModalPosition({ 
                // right:pos.right,
                // @ts-ignore
                top:pos.bottom+10,left:pos.left+pos.width-150,width:100,position:'fixed'})
              setShowLanModal(true)
            }} >
              {/* {t('language')} */}
                <img src={languages[langIndex]?.logo} style={{width:20,height:20,marginRight:5}}/>
                <div>{languages[langIndex]?.title}</div>
                <IoIosArrowDown style={{marginLeft:5}}/>
              </div> 
            <Modal footer={null} bodyStyle={{padding:10}} closable={false} open={showLanModal} style={modalPosition} width={150} onCancel={()=>setShowLanModal(false)}>
              {languages.map((l,index,arr)=>{
                return <div onClick={()=>{
                  setLangIndex(index)
                  setShowLanModal(false)
                  stores.TodoList.langIndex = index
                  // alert('fdsa')
                }} style={{paddingBottom:index==arr.length-1?0:10,display:'flex',alignItems:'center', flexDirection:'row',justifyContent:'space-between'}}>
                  <div style={{color:'gray'}}>
                    <img src={l.logo} style={{width:24,height:24,marginRight:10}}/>{l.title}
                  </div>
                  {index==langIndex ?<MdRadioButtonChecked style={{marginLeft:10,color:blue[900],fontSize:16}}/>
                  :<MdRadioButtonUnchecked style={{marginLeft:10,color:'gray',fontSize:16}}/>}
                </div>
              })}
            </Modal>
          </div>
        </span>
        {domainConfig && <div style={{marginTop:30,borderRadius:10,overflow:'hidden',position:'relative',}}>
          <img style={{width:'100%'}} src={bannerBg}/>
          <div style={{position:'absolute',padding:20,left:0,right:'50%',top:0,bottom:0,display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:'center'}}>
              <div style={{color:'#3C4DE5',fontWeight:'bold',lineHeight:'100%',fontSize:18}}>{t('Hacker Predictions')}</div>
              <div style={{height:5}}/> 
              <div style={{color:'white',fontSize:14}}>{t('Using Telegram')}</div>
              <div style={{height:5}}/>
              <div  onClick={()=>window.open(domainConfig.get('whatsappURL')||domainConfig.get('telegramURL'),'_blank')} style={{background:blue[900],fontSize:14,color:'white',paddingLeft:10,paddingRight:10, borderRadius:100,overflow:'hidden',textAlign:'center'}}>{t('Contact')}</div>
          </div>
        </div>}
        {/* {domainConfig && <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:10}}>
              <img src={hacker} alt='' style={{width:'20%',marginRight:10}} />
              <div style={{marginTop:10}}>
                <div style={{ fontSize:14,color:'white'}}>
                  {t('USE FOLLOWING REGISTER LINK TO GET MORE ACCURATE HACKER PREDICTIONS')}.
                </div>
                <div style={{display:'flex',justifyContent:'space-around',marginTop:5}}>
                  <Button style={{borderRadius:30,padding:'0px 7px'}} onClick={()=>window.open(domainConfig.get('registerURL'),'_blank')}>Register</Button> 
                  <Button style={{borderRadius:30,padding:'0px 7px',display:'flex',alignItems:'center'}} onClick={()=>window.open(domainConfig.get('whatsappURL'),'_blank')}> 
                    <img src={whatsapp} alt='' style={{width:20,marginRight:5,background:'white',borderRadius:10}} />
                    Contact</Button>
                  <Button style={{borderRadius:30,padding:'0px 7px',display:'flex',alignItems:'center'}} onClick={()=>window.open(domainConfig.get('telegramURL'),'_blank')}> 
                    <img src={telegram} alt='' style={{width:20,marginRight:5}} />
                    Contact</Button>
                </div>
            </div>
         </div>} */}
          <div style={{
            // background: '#ffffff',
        // boxShadow: '0 .05333rem .10667rem #c5c5da40;',
        // borderRadius: 5,
        position: 'relative',
        display: 'flex'}}>
            {/* {lotteries.map((l,i)=>{
              return <StyledCardWrapper style={{flexDirection:'column',flex:1,alignItems:'center',display:'flex',
                      // background:i===selectedTab?'linear-gradient(157deg,#FA5F5F 0%,#FF8C82 100%)':'transparent',
                      color:i===selectedTab?'white':'white',
                      opacity:i===selectedTab?1:0.5,
                      borderRadius:5,
                      marginTop:10,
                    }}
                        onClick={()=>{
                          // setSelectedTab(i)
                          history.push(l.name.toLowerCase())
                        }}
                      > 
                        <img alt='' src={l.img} style={{width:'100%',marginBottom:-20,marginTop:-10}}/>
                        <div >{l.name}</div>
              </StyledCardWrapper>})} */}
      </div>
    </StyledWrapper>
}

interface StyledButtonProps {
  boxShadow: string,
  color: string,
  disabled?: boolean,
  fontSize: number,
  padding: number,
  size: number
}

const StyledButton = styled.button<StyledButtonProps>`
  align-items: center;
  background-color: ${props => props.theme.color.grey[900]};
  border: 0;
  border-radius: 12px;
  box-shadow: ${props => props.boxShadow};
  color: ${props => !props.disabled ? props.color : `${props.color}55`};
  cursor: pointer;
  display: flex;
  font-size: ${props => props.fontSize}px;
  font-weight: 700;
  height: ${props => props.size}px;
  justify-content: center;
  outline: none;
  padding-left: ${props => props.padding}px;
  padding-right: ${props => props.padding}px;
  pointer-events: ${props => !props.disabled ? undefined : 'none'};
  width: 100%;
  &:hover {
    background-color: ${props => props.color};
    color: ${props => props.theme.color.grey[900]};
  }
`

const StyledLink = styled(Link)`
  align-items: center;
  color: inherit;
  display: flex;
  flex: 1;
  height: 56px;
  justify-content: center;
  margin: 0 ${props => -props.theme.spacing[4]}px;
  padding: 0 ${props => props.theme.spacing[4]}px;
  text-decoration: none;
`

const StyledExternalLink = styled.a`
  align-items: center;
  color: inherit;
  display: flex;
  flex: 1;
  height: 56px;
  justify-content: center;
  margin: 0 ${props => -props.theme.spacing[4]}px;
  padding: 0 ${props => props.theme.spacing[4]}px;
  text-decoration: none;
`

export default LotterySegmentTab